// extracted by mini-css-extract-plugin
export default {"border":"dx9mWLkYt38DlctJqIBk"};